import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Carnet, CarnetItem } from '../../../../shared/interface';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-modifica-carnet-backoffice',
  templateUrl: './modifica-carnet-backoffice.component.html',
  styleUrl: './modifica-carnet-backoffice.component.css'
})
export class ModificaCarnetBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  
  formCarnet!: FormGroup;

  carnet?: Carnet;

  ngOnInit(): void {

    this.formCarnet = new FormGroup({})

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getCarnet(id).subscribe({
        next: (data) => this.carnet = data,
        error: (err) => this.router.navigate(['/backoffice/carnet']),
        complete: () => {

          this.carnet?.items.map((contenuto: CarnetItem) => {
            this.formCarnet.addControl('titolo_' + contenuto.id, new FormControl(null, Validators.required))
            this.formCarnet.addControl('descrizione_' + contenuto.id, new FormControl(null))

            this.formCarnet.patchValue({
              ['titolo_' + contenuto.id]: contenuto.titolo,
              ['descrizione_' + contenuto.id]: contenuto.descrizione
            })
          })

        }
      })

    })

  }

  onAddItem() {

    this.carnet?.items.push({
      id: this.carnet?.items!.length + 1,
      id_carnet: this.carnet!.id,
      titolo: '',
      descrizione: '',
      new: true,
      data_creazione: new Date(),
      data_aggiornamento: new Date()
    })

    this.carnet?.items.map((contenuto, index) => {
      this.formCarnet.addControl('titolo_' + contenuto.id, new FormControl(null, Validators.required))
      this.formCarnet.addControl('descrizione_' + contenuto.id, new FormControl(null))
    })

  }

  onRemoveItem(id: number) {
    this.carnet!.items = this.carnet?.items.filter(item => item.id != id) || [];
    
    this.formCarnet.removeControl('titolo_' + id)
    this.formCarnet.removeControl('descrizione_' + id)
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il carnet?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteCarnet(this.carnet!.id).subscribe({
          next: (data) => this.apiService.setDefinizioni(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/carnet']);
            this.apiService.message("success", "Eliminazione", "Il carnet è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    let carnet: any = {
      items: []
    }

    this.carnet?.items.map((item, index) => {
      carnet.items.push({id: item.id, titolo: this.formCarnet.get('titolo_' + item.id)?.value || '', descrizione: this.formCarnet.get('descrizione_' + item.id)?.value || '', new: item.new || false})
    })
    
    this.apiService.updateCarnet(carnet, this.carnet!.id).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.setCarnets();
        this.apiService.message('success', 'Successo', 'Il carnet è stato modificato con successo!');
        this.router.navigate(['/backoffice/carnet'])
      }
    })

  }

}
